import { TruckCapacityStatusEnum, TruckTransportT } from './types';

export const truckSorter = (a: TruckTransportT, b: TruckTransportT): number => {
  if (
    a.capacityStatus === TruckCapacityStatusEnum.HasCapacity &&
    b.capacityStatus === TruckCapacityStatusEnum.NoCapacity
  ) {
    return -1;
  } else if (
    a.capacityStatus === TruckCapacityStatusEnum.NoCapacity &&
    b.capacityStatus === TruckCapacityStatusEnum.HasCapacity
  ) {
    return 1;
  }

  const dateA = new Date(a.originEmptyDate).getTime();
  const dateB = new Date(b.originEmptyDate).getTime();

  return dateA - dateB;
};
